import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { OrganizationKeyName } from "../../model/Organization";
import { RootState } from "../../store";

import { MemberCardType } from "./models/MemberCardType";
import { colors } from "../../components/colors";
import { InLineLabel } from "../../components/Label";
import { TableRow } from "../../components/table-components/TableRow";
import { TableCellLink } from "../../components/table-components/TableCellLink";
import { StyledText } from "../../assets/typography/typography";

interface OwnProps {
  organization: OrganizationKeyName;
  memberCardType: MemberCardType;
  href: string;
}

interface Props extends OwnProps {}

interface State {}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  return {};
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {};
};

class MemberCardTypeListRow extends React.Component<Props, State> {
  render() {
    const memberCardType = this.props.memberCardType;
    const href = this.props.href;

    return (
      <TableRow>
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {memberCardType.name}
          </StyledText>
        </TableCellLink>
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {memberCardType.onlinePosGroup}
          </StyledText>
        </TableCellLink>
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {memberCardType.visible ? (
              <InLineLabel
                backgroundColor={colors.successLight}
                color={colors.successDark}
              >
                Visible
              </InLineLabel>
            ) : (
              <InLineLabel
                backgroundColor={colors.ctaInactive}
                color={colors.textPrimary}
              >
                Not visible
              </InLineLabel>
            )}
          </StyledText>
        </TableCellLink>
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {memberCardType.disabled ? (
              <InLineLabel
                backgroundColor={colors.errorLight}
                color={colors.errorDark}
              >
                Disabled
              </InLineLabel>
            ) : (
              <InLineLabel
                backgroundColor={colors.successLight}
                color={colors.successDark}
              >
                Enabled
              </InLineLabel>
            )}
          </StyledText>
        </TableCellLink>
      </TableRow>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberCardTypeListRow);
